export default __webpack_public_path__ + "static/account-area-hero-mobile-9e4b83b35187fe1cdce72128c12085eb.jpg";